<template>
  <v-dialog v-model="show" persistent lazy max-width="600">
    <v-card>
      <v-card-title class="title">Отправка документов</v-card-title>
      <v-card-text>
        <v-autocomplete
          v-if="organizations.length > 0"
          label="Организация"
          item-text="name"
          v-model="organization"
          return-object
          clearable
          @change="onChangeOrganization()"
          :items="organizations">
        </v-autocomplete>
        <v-form ref="send_doc_form" v-model="valid" lazy-validation>
          <v-text-field
            v-model.trim="edrpou"
            :error-messages="errors.edrpou"
            :rules="rules.edrpou"
            label="ЕДРПОУ"></v-text-field>
          <v-text-field
            v-model.trim="drfo"
            :error-messages="errors.drfo"
            :rules="rules.drfo"
            label="ДРФО"></v-text-field>
        </v-form>
        <v-alert v-if="done" :value="true" type="success">
          Документ успешно отправлен.
        </v-alert>
        <v-alert v-if="errors.common" :value="true" type="error">
          {{errors.common[0]}}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="show = false">Закрыть</v-btn>
        <v-btn v-if="!done" flat color="pink" :loading="loading" :disabled="!valid"
               @click="onSubmit()">Отправить</v-btn>
        <v-btn v-if="done" flat color="green" @click="show = false">Готово</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DocumentSendDialog',
  props: ['value', 'document'],
  data () {
    return {
      valid: true,
      done: false,
      loading: false,
      edrpou: '',
      drfo: '',
      organization: '',
      errors: {
        edrpou: [],
        drfo: [],
      },
      rules: {
        edrpou: [this.validateEdrpou],
        drfo: [this.validateDrfo],
      }
    }
  },
  methods: {
    async onSubmit () {

      delete this.errors.common

      if (!this.$refs.send_doc_form.validate())
        return

      this.loading = true
      this.$store.dispatch('sendDocument', {document_id: this.document.id, data: {drfo: this.drfo, edrpou: this.edrpou}})
        .then(() => {
          this.$emit('done')
          this.done = true
        })
        .catch((err) => {
          this.errors = err.response.data.errors
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateEdrpou (value) {
      if (!value)
        return true

      if (value && value.match(/^[0-9]{8,10}$/y) !== null)
        return true

      return 'Неверный формат ЕДРПОУ. Ожидается 8-10 цифр.'
    },
    validateDrfo (value) {
      if (!value)
        return true

      if (value && value.match(/^[0-9]{10}$/y) !== null)
        return true

      return 'Неверный формат ДРФО. Ожидается 10 цифр.'
    },
    onClose () {
      this.done = false
      this.loading = false
      this.$set(this.errors, {})
      this.$refs.send_doc_form.reset()
      this.organization = undefined
      this.$emit('close')
    },
    onChangeOrganization () {
      if (!this.organization) {
        this.edrpou = ''
        this.drfo = ''
        return
      }

      this.edrpou = this.organization.edrpou
      this.drfo = this.organization.drfo
    }
  },
  computed: {
    ...mapState(['organizations']),
    show: {
      get () {
        return this.value
      },
      set (newValue) {
        if (!newValue) {
          this.onClose()
        }
      }
    }
  },
  created () {
    this.$store.dispatch('getOrganizationList')
  }
}
</script>